var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "akl" }, [
    _c(
      "div",
      {
        staticClass: "layerWrapper pop_womanhealth",
        staticStyle: { display: "none" },
        attrs: { tabindex: "0" }
      },
      [
        _c("div", { staticClass: "cbox layerBox popWidM" }, [
          _c("div", { staticClass: "cart-popup__dialog" }, [
            _c("div", { staticClass: "cart-popup__header" }, [
              _c("span", { staticClass: "cart-popup__header-text" }, [
                _vm._v("\n          뉴트리라이트 갱년기 자가진단\n          "),
                _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMode == 12,
                        expression: "showMode == 12"
                      }
                    ],
                    staticClass: "cart-popup_cc",
                    attrs: {
                      href: "#",
                      "data-dismiss": "modal",
                      "aria-label": "Close",
                      "aria-hidden": "true"
                    },
                    on: { click: _vm.init }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src:
                          "https://www.amway.co.kr/_ui/responsive/theme-blue/images/reload.png",
                        alt: "새로고침"
                      }
                    })
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMode != 12,
                    expression: "showMode != 12"
                  }
                ],
                staticClass: "cart-popup__content height-auto"
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMode == 0,
                        expression: "showMode == 0"
                      }
                    ],
                    staticClass: "content_womanhealth"
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c("p", { staticClass: "wh_txt txtC marB" }, [
                      _vm._v(
                        "\n            MRS II(갱년기 정도 평가지수)*를 활용한\n            갱년기 자가진단을 통해 나의 몸을 이해하고\n            적극적으로 관리해보세요.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(2)
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: 0 < _vm.showMode && _vm.showMode < 12,
                        expression: "0 < showMode && showMode < 12"
                      }
                    ],
                    staticClass: "content_womanhealth"
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 1,
                            expression: "showMode == 1"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(3),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _vm._m(5)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 2,
                            expression: "showMode == 2"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _vm._m(7),
                        _vm._v(" "),
                        _vm._m(8),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "wh_comment txtC",
                            attrs: { id: "comment_q02" }
                          },
                          [
                            _vm._v(
                              "\n              * 갑자기 가슴이 두근거림, 맥박이 건너 뜀, 박동이 빨라짐, 가슴이 조여드는 느낌\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 3,
                            expression: "showMode == 3"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(9),
                        _vm._v(" "),
                        _vm._m(10),
                        _vm._v(" "),
                        _vm._m(11),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "wh_comment txtC",
                            attrs: { id: "comment_q03" }
                          },
                          [
                            _vm._v(
                              "\n              * 잠들기 어려움, 수면을 지속하기 어려움, 잠에서 이르게 깸\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 4,
                            expression: "showMode == 4"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(12),
                        _vm._v(" "),
                        _vm._m(13),
                        _vm._v(" "),
                        _vm._m(14),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "wh_comment txtC",
                            attrs: { id: "comment_q04" }
                          },
                          [
                            _vm._v(
                              "\n              * 기분이 쳐짐, 슬픔, 쉽게 눈물이 남, 의욕 없음, 감정이 수시로 변함\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 5,
                            expression: "showMode == 5"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(15),
                        _vm._v(" "),
                        _vm._m(16),
                        _vm._v(" "),
                        _vm._m(17),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "wh_comment txtC",
                            attrs: { id: "comment_q05" }
                          },
                          [
                            _vm._v(
                              "\n              * 신경이 날카로워지는 느낌, 내적인 긴장감, 공격적으로 되는 느낌\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 6,
                            expression: "showMode == 6"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(18),
                        _vm._v(" "),
                        _vm._m(19),
                        _vm._v(" "),
                        _vm._m(20),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "wh_comment txtC",
                            attrs: { id: "comment_q06" }
                          },
                          [
                            _vm._v(
                              "\n              * 내적인 초조감, 공황상태가 되는 느낌\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 7,
                            expression: "showMode == 7"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(21),
                        _vm._v(" "),
                        _vm._m(22),
                        _vm._v(" "),
                        _vm._m(23)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 8,
                            expression: "showMode == 8"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(24),
                        _vm._v(" "),
                        _vm._m(25),
                        _vm._v(" "),
                        _vm._m(26)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 9,
                            expression: "showMode == 9"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(27),
                        _vm._v(" "),
                        _vm._m(28),
                        _vm._v(" "),
                        _vm._m(29),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "wh_comment txtC",
                            attrs: { id: "comment_q09" }
                          },
                          [
                            _vm._v(
                              "\n              * 배뇨 어려움, 소변이 자주 마려움, 요실금 등\n            "
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 10,
                            expression: "showMode == 10"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(30),
                        _vm._v(" "),
                        _vm._m(31),
                        _vm._v(" "),
                        _vm._m(32)
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMode == 11,
                            expression: "showMode == 11"
                          }
                        ],
                        staticClass: "marB"
                      },
                      [
                        _vm._m(33),
                        _vm._v(" "),
                        _vm._m(34),
                        _vm._v(" "),
                        _vm._m(35)
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", [
                      _vm._m(36),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix txtC amway-theme" }, [
                        _c("label", { staticClass: "fl20" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "amw-radio-wrap radio-label txtC focus"
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.score,
                                    expression: "score"
                                  }
                                ],
                                staticClass: "amw-global-radio",
                                attrs: {
                                  type: "radio",
                                  name: "point",
                                  checked: "checked",
                                  value: "0"
                                },
                                domProps: { checked: _vm._q(_vm.score, "0") },
                                on: {
                                  change: function($event) {
                                    _vm.score = "0"
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("0점")]),
                          _vm._v(" "),
                          _c("img", {
                            staticStyle: { "max-width": "20px" },
                            attrs: {
                              src:
                                "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point01.png",
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(37)
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "fl20" }, [
                          _c(
                            "span",
                            { staticClass: "amw-radio-wrap radio-label txtC" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.score,
                                    expression: "score"
                                  }
                                ],
                                staticClass: "amw-global-radio",
                                attrs: {
                                  type: "radio",
                                  name: "point",
                                  value: "1"
                                },
                                domProps: { checked: _vm._q(_vm.score, "1") },
                                on: {
                                  change: function($event) {
                                    _vm.score = "1"
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("1점")]),
                          _vm._v(" "),
                          _c("img", {
                            staticStyle: { "max-width": "20px" },
                            attrs: {
                              src:
                                "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point02.png",
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(38)
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "fl20" }, [
                          _c(
                            "span",
                            { staticClass: "amw-radio-wrap radio-label txtC" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.score,
                                    expression: "score"
                                  }
                                ],
                                staticClass: "amw-global-radio",
                                attrs: {
                                  type: "radio",
                                  name: "point",
                                  value: "2"
                                },
                                domProps: { checked: _vm._q(_vm.score, "2") },
                                on: {
                                  change: function($event) {
                                    _vm.score = "2"
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("2점")]),
                          _vm._v(" "),
                          _c("img", {
                            staticStyle: { "max-width": "20px" },
                            attrs: {
                              src:
                                "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point03.png",
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(39)
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "fl20" }, [
                          _c(
                            "span",
                            { staticClass: "amw-radio-wrap radio-label txtC" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.score,
                                    expression: "score"
                                  }
                                ],
                                staticClass: "amw-global-radio",
                                attrs: {
                                  type: "radio",
                                  name: "point",
                                  value: "3"
                                },
                                domProps: { checked: _vm._q(_vm.score, "3") },
                                on: {
                                  change: function($event) {
                                    _vm.score = "3"
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("3점")]),
                          _vm._v(" "),
                          _c("img", {
                            staticStyle: { "max-width": "20px" },
                            attrs: {
                              src:
                                "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point04.png",
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(40)
                        ]),
                        _vm._v(" "),
                        _c("label", { staticClass: "fl20" }, [
                          _c(
                            "span",
                            { staticClass: "amw-radio-wrap radio-label txtC" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.score,
                                    expression: "score"
                                  }
                                ],
                                staticClass: "amw-global-radio",
                                attrs: {
                                  type: "radio",
                                  name: "point",
                                  value: "4"
                                },
                                domProps: { checked: _vm._q(_vm.score, "4") },
                                on: {
                                  change: function($event) {
                                    _vm.score = "4"
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "amw-radio-overlay txtC"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("4점")]),
                          _vm._v(" "),
                          _c("img", {
                            staticStyle: { "max-width": "20px" },
                            attrs: {
                              src:
                                "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point05.png",
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(41)
                        ])
                      ])
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMode == 12,
                    expression: "showMode == 12"
                  }
                ],
                staticClass: "cart-popup__content womanhealth_result"
              },
              [
                _c("div", { staticClass: "content_womanhealth" }, [
                  _vm._m(42),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.sum < 5,
                          expression: "sum < 5"
                        }
                      ],
                      staticClass: "txtC padT marB"
                    },
                    [
                      _c("p", { staticClass: "wh_txt" }, [
                        _vm._v("\n              나의 갱년기 상태\n            ")
                      ]),
                      _vm._v(" "),
                      _vm._m(43),
                      _vm._v(" "),
                      _vm._m(44)
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: 4 < _vm.sum && _vm.sum < 9,
                          expression: "4 < sum && sum < 9"
                        }
                      ],
                      staticClass: "txtC padT marB"
                    },
                    [
                      _c("p", { staticClass: "wh_txt" }, [
                        _vm._v("\n              나의 갱년기 상태\n            ")
                      ]),
                      _vm._v(" "),
                      _vm._m(45),
                      _vm._v(" "),
                      _vm._m(46)
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: 8 < _vm.sum && _vm.sum < 16,
                          expression: "8 < sum && sum < 16"
                        }
                      ],
                      staticClass: "txtC padT marB"
                    },
                    [
                      _c("p", { staticClass: "wh_txt" }, [
                        _vm._v("\n              나의 갱년기 상태\n            ")
                      ]),
                      _vm._v(" "),
                      _vm._m(47),
                      _vm._v(" "),
                      _vm._m(48)
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: 15 < _vm.sum,
                          expression: "15 < sum"
                        }
                      ],
                      staticClass: "txtC padT marB"
                    },
                    [
                      _c("p", { staticClass: "wh_txt" }, [
                        _vm._v("\n              나의 갱년기 상태\n            ")
                      ]),
                      _vm._v(" "),
                      _vm._m(49),
                      _vm._v(" "),
                      _vm._m(50)
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.sum < 5,
                          expression: "sum < 5"
                        }
                      ],
                      staticClass: "marB txtC",
                      staticStyle: {
                        border: "1px solid #dadada",
                        padding: "20px"
                      }
                    },
                    [
                      _c("p", { staticClass: "wh_txt" }, [
                        _vm._v("나의 갱년기 증상 점수")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "wh_txt" }, [
                        _c("span", { staticClass: "wh_tit" }, [
                          _c("strong", { staticClass: "color_result01" }, [
                            _vm._v(_vm._s(_vm.sum))
                          ])
                        ]),
                        _vm._v(" 점")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: 4 < _vm.sum && _vm.sum < 9,
                          expression: "4 < sum && sum < 9"
                        }
                      ],
                      staticClass: "marB txtC",
                      staticStyle: {
                        border: "1px solid #dadada",
                        padding: "20px"
                      }
                    },
                    [
                      _c("p", { staticClass: "wh_txt" }, [
                        _vm._v("나의 갱년기 증상 점수")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "wh_txt" }, [
                        _c("span", { staticClass: "wh_tit" }, [
                          _c("strong", { staticClass: "color_result02" }, [
                            _vm._v(_vm._s(_vm.sum))
                          ])
                        ]),
                        _vm._v(" 점")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: 8 < _vm.sum && _vm.sum < 16,
                          expression: "8 < sum && sum < 16"
                        }
                      ],
                      staticClass: "marB txtC",
                      staticStyle: {
                        border: "1px solid #dadada",
                        padding: "20px"
                      }
                    },
                    [
                      _c("p", { staticClass: "wh_txt" }, [
                        _vm._v("나의 갱년기 증상 점수")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "wh_txt" }, [
                        _c("span", { staticClass: "wh_tit" }, [
                          _c("strong", { staticClass: "color_result03" }, [
                            _vm._v(_vm._s(_vm.sum))
                          ])
                        ]),
                        _vm._v(" 점")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: 15 < _vm.sum,
                          expression: "15 < sum"
                        }
                      ],
                      staticClass: "marB txtC",
                      staticStyle: {
                        border: "1px solid #dadada",
                        padding: "20px"
                      }
                    },
                    [
                      _c("p", { staticClass: "wh_txt" }, [
                        _vm._v("나의 갱년기 증상 점수")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "wh_txt" }, [
                        _c("span", { staticClass: "wh_tit" }, [
                          _c("strong", { staticClass: "color_result04" }, [
                            _vm._v(_vm._s(_vm.sum))
                          ])
                        ]),
                        _vm._v(" 점")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.sum < 5,
                          expression: "sum < 5"
                        }
                      ],
                      staticClass: "clearfix marB txtC",
                      staticStyle: {
                        border: "1px solid #dadada",
                        padding: "20px"
                      }
                    },
                    [
                      _vm._m(51),
                      _vm._v(" "),
                      _c("div", { staticClass: "fl50" }, [
                        _vm._m(52),
                        _vm._v(" "),
                        _c("p", [
                          _c("span", { staticClass: "wh_tit" }, [
                            _c("strong", { staticClass: "color_result01" }, [
                              _vm._v(_vm._s(_vm.sum - 14))
                            ])
                          ]),
                          _vm._v("점")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: 4 < _vm.sum && _vm.sum < 9,
                          expression: "4 < sum && sum < 9"
                        }
                      ],
                      staticClass: "clearfix marB txtC",
                      staticStyle: {
                        border: "1px solid #dadada",
                        padding: "20px"
                      }
                    },
                    [
                      _vm._m(53),
                      _vm._v(" "),
                      _c("div", { staticClass: "fl50" }, [
                        _vm._m(54),
                        _vm._v(" "),
                        _c("p", [
                          _c("span", { staticClass: "wh_tit" }, [
                            _c("strong", { staticClass: "color_result02" }, [
                              _vm._v(_vm._s(_vm.sum - 14))
                            ])
                          ]),
                          _vm._v("점")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: 8 < _vm.sum && _vm.sum < 16,
                          expression: "8 < sum && sum < 16"
                        }
                      ],
                      staticClass: "clearfix marB txtC",
                      staticStyle: {
                        border: "1px solid #dadada",
                        padding: "20px"
                      }
                    },
                    [
                      _vm._m(55),
                      _vm._v(" "),
                      _c("div", { staticClass: "fl50" }, [
                        _vm._m(56),
                        _vm._v(" "),
                        _c("p", [
                          _c("span", { staticClass: "wh_tit" }, [
                            _c("strong", { staticClass: "color_result03" }, [
                              _vm._v(_vm._s(_vm.sum - 14))
                            ])
                          ]),
                          _vm._v("점")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: 15 < _vm.sum,
                          expression: "15 < sum"
                        }
                      ],
                      staticClass: "clearfix marB txtC",
                      staticStyle: {
                        border: "1px solid #dadada",
                        padding: "20px"
                      }
                    },
                    [
                      _vm._m(57),
                      _vm._v(" "),
                      _c("div", { staticClass: "fl50" }, [
                        _vm._m(58),
                        _vm._v(" "),
                        _c("p", [
                          _c("span", { staticClass: "wh_tit" }, [
                            _c("strong", { staticClass: "color_result04" }, [
                              _vm._v(_vm._s(_vm.sum - 14))
                            ])
                          ]),
                          _vm._v("점")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "wh_comment" }, [
                    _vm._v(
                      "\n            * 김지현 등, 폐경기 여성의 갱년기 증상과 인지기능 감퇴와의\n            관계 : 건강증진행위의 매개효과, Korean Journal of Adult\n            Nursing Vol.29 No.2, 200-210, April 2017\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(59),
                _vm._v(" "),
                _vm._m(60)
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showMode != 12,
                    expression: "showMode != 12"
                  }
                ],
                staticClass: "cart-popup__item-link"
              },
              [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMode == 0,
                        expression: "showMode == 0"
                      }
                    ],
                    staticClass: "bt-akl-blue bt-whpop-purple",
                    style: { width: "90%" },
                    attrs: { type: "button" },
                    on: { click: _vm.start }
                  },
                  [_vm._v("자가진단 시작!")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMode > 1 && _vm.showMode < 12,
                        expression: "showMode > 1 && showMode < 12"
                      }
                    ],
                    staticClass: "bt-akl-blue bt-whpop-gray",
                    attrs: { type: "button" },
                    on: { click: _vm.goBack }
                  },
                  [_vm._v("이전")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMode > 0 && _vm.showMode < 11,
                        expression: "showMode > 0 && showMode < 11"
                      }
                    ],
                    staticClass: "bt-akl-blue bt-whpop-purple",
                    style: { width: _vm.showMode == 1 ? "90%" : "" },
                    attrs: { type: "button" },
                    on: { click: _vm.goNext }
                  },
                  [_vm._v("다음")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showMode == 11,
                        expression: "showMode == 11"
                      }
                    ],
                    staticClass: "bt-akl-blue bt-whpop-purple",
                    attrs: { type: "button" },
                    on: { click: _vm.goResult }
                  },
                  [_vm._v("결과 확인하기")]
                )
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _vm._v("\n            바쁜 일상 속에서 놓치고 있었던 내 몸의 신호!"),
      _c("br"),
      _vm._v(" "),
      _c("strong", { staticClass: "color_purple" }, [
        _vm._v(
          "갱년기 자가진단을 통해 나의 몸을 이해하고 갱년기를 적극적으로 관리해보세요!"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/vis01.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_comment" }, [
      _vm._v(
        "\n            * MRS II(갱년기 정도 평가지수)란? : 갱년기 여성의 삶의 질을 평가하는 도구로 심리적 증상, 신체 증상, 비뇨 생식기 증상 등의 총 11개 문항으로 구성되며 각 문항에 대해서 0점(없음)에서 4점(매우 심함)의 점수로 평가합니다."
      ),
      _c("br"),
      _vm._v(
        "\n            ※ 한국암웨이㈜는 본 설문조사에 대한 귀하의 자가진단 결과 정보를 별도로 수집하거나 이용하지 않습니다.\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("1")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q01.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v("\n              얼굴에 갑자기 열감이 느껴지고 붉어지며,"),
        _c("br"),
        _vm._v("\n              갑작스럽게 땀이 난다.\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("2")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q02.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v("\n              심장 불편감"),
        _c("sup", [
          _c(
            "a",
            { staticClass: "color_purple", attrs: { href: "#comment_q02" } },
            [_vm._v("*")]
          )
        ]),
        _vm._v("이 있다.\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("3")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q03.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v("\n              수면 문제"),
        _c("sup", [
          _c(
            "a",
            { staticClass: "color_purple", attrs: { href: "#comment_q03" } },
            [_vm._v("*")]
          )
        ]),
        _vm._v("를 겪는다.\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("4")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q04.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v("\n              우울한 기분"),
        _c("sup", [
          _c(
            "a",
            { staticClass: "color_purple", attrs: { href: "#comment_q04" } },
            [_vm._v("*")]
          )
        ]),
        _vm._v("이 든다.\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("5")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q05.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v("\n              과민한 느낌"),
        _c("sup", [
          _c(
            "a",
            { staticClass: "color_purple", attrs: { href: "#comment_q05" } },
            [_vm._v("*")]
          )
        ]),
        _vm._v("이 든다.\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("6")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q06.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v("\n              불안감"),
        _c("sup", [
          _c(
            "a",
            { staticClass: "color_purple", attrs: { href: "#comment_q05" } },
            [_vm._v("*")]
          )
        ]),
        _vm._v("을 느낀다.\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("7")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q07.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v("\n              신체 및 정신적 피로를 느낀다.\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("8")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q08.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v(
          "\n              성적 욕구나 성적 만족감의 변화가 있다.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("9")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q09.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v("\n              배뇨 문제"),
        _c("sup", [
          _c(
            "a",
            { staticClass: "color_purple", attrs: { href: "#comment_q04" } },
            [_vm._v("*")]
          )
        ]),
        _vm._v("를 겪는다.\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("10")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q10.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v("\n              질 건조감을 느낀다.\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [_vm._v("11")]),
      _vm._v(" / 11\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txtC marB" }, [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/q11.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit txtC" }, [
      _c("b", { staticClass: "color_purple" }, [
        _vm._v(
          "\n              관절 및 근육의 통증이나 불편감을 느낀다.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "clearfix" }, [
      _c("div", { staticClass: "fl20 pointC0" }),
      _vm._v(" "),
      _c("div", { staticClass: "fl20 pointC1" }),
      _vm._v(" "),
      _c("div", { staticClass: "fl20 pointC2" }),
      _vm._v(" "),
      _c("div", { staticClass: "fl20 pointC3" }),
      _vm._v(" "),
      _c("div", { staticClass: "fl20 pointC4" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("전혀"),
      _c("br"),
      _vm._v(" 그렇지"),
      _c("br"),
      _vm._v(" 않다")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_vm._v("가끔"), _c("br"), _vm._v(" 그렇다")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_vm._v("종종"), _c("br"), _vm._v(" 그렇다")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_vm._v("자주"), _c("br"), _vm._v(" 그렇다")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("매우"),
      _c("br"),
      _vm._v(" 자주"),
      _c("br"),
      _vm._v(" 그렇다")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit color_purple txtC padT" }, [
      _c("strong", [
        _vm._v("\n            나의 갱년기 건강 분석 결과 확인하기\n          ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit" }, [
      _c("strong", { staticClass: "color_result01" }, [
        _vm._v("갱년기 증상 거의 없음")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/result01.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit" }, [
      _c("strong", { staticClass: "color_result02" }, [
        _vm._v("경미한 갱년기 상태")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/result02.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit" }, [
      _c("strong", { staticClass: "color_result03" }, [
        _vm._v("중증도의 갱년기 상태")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/result03.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "wh_tit" }, [
      _c("strong", { staticClass: "color_result04" }, [
        _vm._v("극심한 갱년기 상태")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/result04.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fl50" }, [
      _c("p", { staticClass: "wh_txt" }, [_vm._v("평균점수")]),
      _vm._v(" "),
      _c("p", [
        _c("span", { staticClass: "wh_tit" }, [_c("strong", [_vm._v("14")])]),
        _vm._v("점"),
        _c("sup", [_c("a", { attrs: { href: "#comment02" } }, [_vm._v("*")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { "max-width": "20px" },
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point01.png",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fl50" }, [
      _c("p", { staticClass: "wh_txt" }, [_vm._v("평균점수")]),
      _vm._v(" "),
      _c("p", [
        _c("span", { staticClass: "wh_tit" }, [_c("strong", [_vm._v("14")])]),
        _vm._v("점"),
        _c("sup", [_c("a", { attrs: { href: "#comment02" } }, [_vm._v("*")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { "max-width": "20px" },
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point02.png",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fl50" }, [
      _c("p", { staticClass: "wh_txt" }, [_vm._v("평균점수")]),
      _vm._v(" "),
      _c("p", [
        _c("span", { staticClass: "wh_tit" }, [_c("strong", [_vm._v("14")])]),
        _vm._v("점"),
        _c("sup", [_c("a", { attrs: { href: "#comment02" } }, [_vm._v("*")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { "max-width": "20px" },
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point03.png",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fl50" }, [
      _c("p", { staticClass: "wh_txt" }, [_vm._v("평균점수")]),
      _vm._v(" "),
      _c("p", [
        _c("span", { staticClass: "wh_tit" }, [_c("strong", [_vm._v("14")])]),
        _vm._v("점"),
        _c("sup", [_c("a", { attrs: { href: "#comment02" } }, [_vm._v("*")])])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticStyle: { "max-width": "20px" },
        attrs: {
          src:
            "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/point04.png",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_womanhealth" }, [
      _c("p", { staticClass: "wh_tit color_purple txtC padT" }, [
        _c("strong", [
          _vm._v("\n            갱년기 증상 Top 3"),
          _c("sup", [
            _c(
              "a",
              { staticClass: "color_purple", attrs: { href: "#comment02" } },
              [_vm._v("*")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("ol", { staticClass: "clearfix txtC" }, [
        _c("li", { staticClass: "fl33" }, [
          _c("div", [
            _c("img", {
              attrs: {
                src:
                  "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/best01.jpg",
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "wh_txt padT" }, [_vm._v("1위")]),
          _vm._v(" "),
          _c("p", { staticClass: "wh_tit" }, [
            _c("b", { staticClass: "color_purple" }, [_vm._v("수면 문제")])
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "fl33" }, [
          _c("div", [
            _c("img", {
              attrs: {
                src:
                  "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/best02.jpg",
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "wh_txt padT" }, [_vm._v("2위")]),
          _vm._v(" "),
          _c("p", { staticClass: "wh_tit" }, [
            _c("b", { staticClass: "color_purple" }, [_vm._v("피로감")])
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "fl33" }, [
          _c("div", [
            _c("img", {
              attrs: {
                src:
                  "https://www.amway.co.kr/_ui/responsive/theme-blue/images/womanhealth/best03.jpg",
                alt: ""
              }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "wh_txt padT" }, [_vm._v("3위")]),
          _vm._v(" "),
          _c("p", { staticClass: "wh_tit" }, [
            _c("b", { staticClass: "color_purple" }, [_vm._v("안면홍조")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "wh_comment padT", attrs: { id: "comment02" } }, [
        _vm._v("* Chuni and Sreeramareddy BMC Women’s Health 2011, 11:30")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_womanhealth" }, [
      _c("p", { staticClass: "wh_tit color_purple txtC padT" }, [
        _c("strong", [
          _vm._v(
            "\n            갱년기 증상 점수에 따른 갱년기 상태\n          "
          )
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("table", { staticClass: "wh_table" }, [
        _c("caption", [_vm._v("\n              점수 별 상태\n            ")]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c(
              "th",
              {
                staticStyle: { "background-color": "#d0e9e2" },
                attrs: { scope: "row" }
              },
              [_vm._v("\n                  0~4점\n                ")]
            ),
            _vm._v(" "),
            _c("td", [
              _c("p", { staticClass: "color_result01" }, [
                _vm._v("갱년기 증상 거의 없음")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c(
              "th",
              {
                staticStyle: { "background-color": "#e8f1cd" },
                attrs: { scope: "row" }
              },
              [_vm._v("\n                  5~8점\n                ")]
            ),
            _vm._v(" "),
            _c("td", [
              _c("p", { staticClass: "color_result02" }, [
                _vm._v("경미한 갱년기 상태")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c(
              "th",
              {
                staticStyle: { "background-color": "#fdeac8" },
                attrs: { scope: "row" }
              },
              [_vm._v("\n                  9~15점\n                ")]
            ),
            _vm._v(" "),
            _c("td", [
              _c("p", { staticClass: "color_result03" }, [
                _vm._v("중증도의 갱년기 상태")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c(
              "th",
              {
                staticStyle: { "background-color": "#f7d9d2" },
                attrs: { scope: "row" }
              },
              [_vm._v("\n                  16점 이상\n                ")]
            ),
            _vm._v(" "),
            _c("td", [
              _c("p", { staticClass: "color_result04" }, [
                _vm._v("극심한 갱년기 상태")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a29a05ec", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a29a05ec","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/self-diagnosis/index.vue
// module id = null
// module chunks = 